// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IcXr","colBig":"styles_colBig__2Azo0","colSmall":"styles_colSmall__hs2gl"};